import * as XLSX from 'xlsx';
import { hadColumnsAccess } from '@/core/domain/model/permission';
import { snackbar } from '@/core/controller/snackbar_controller';

export function filterHeadersByPermission(headers, permissionID) {
    return headers.filter(header => {
        const columnPermissionID = header.permissionID ?? permissionID;
    
        return hadColumnsAccess(header.value, columnPermissionID);
    });
}

export function buildExcelData(items, headers) {
    return items.map(item => {
        const transformedItem = {};

        headers.forEach(header => {
            const value = item[header.value];

            if (header.transformer && typeof header.transformer === 'function') {
                transformedItem[header.value] = header.transformer(value);
            } else {
                transformedItem[header.value] = value;
            }
        });

        return transformedItem;
    });
}

export async function generateExcelFile(items, headers, permissionID, filename, sheetName = 'Sheet1') {
    try {
        const filteredHeaders = filterHeadersByPermission(headers, permissionID);

        const headerTexts = filteredHeaders.map(h => h.text);

        const transformedData = buildExcelData(items, filteredHeaders);

        const mappedData = transformedData.map(item => {
            const mappedItem = {};
            filteredHeaders.forEach(header => {
                mappedItem[header.text] = item[header.value];
            });
            return mappedItem;
        });

        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet([]);

        XLSX.utils.sheet_add_aoa(ws, [headerTexts]);

        XLSX.utils.sheet_add_json(ws, mappedData, {
            origin: 'A2',
            skipHeader: true
        });

        XLSX.utils.book_append_sheet(wb, ws, sheetName);
        XLSX.writeFile(wb, `${filename}.xlsx`);

    } catch (error) {
        console.error('Erro ao exportar Excel:', error);
        snackbar.show({ message: error.toString() });
        throw error;
    }
}
